<template>
    <modal id="banner-modal"
           v-model="showModal"
           :title="generateModalTitle('earner')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader"
    >
        <app-form-group
                type="number"
                :label="$t('rank')"
                v-model="formData.rank"
                :placeholder="$placeholder('rank')"
                :errorMessage="$errorMessage(errors, 'rank')"
        />

        <app-form-group
                :label="$t('rank_text')"
                v-model="formData.rank_text"
                :placeholder="$placeholder('rank_text')"
                :errorMessage="$errorMessage(errors, 'rank_text')"
        />

        <app-form-group
                :label="$t('name')"
                v-model="formData.name"
                :placeholder="$placeholder('name')"
                :errorMessage="$errorMessage(errors, 'name')"
        />
        <div class="form-group">
            <label for="image">{{ $t('image') }}</label>
            <app-input
                    :generate-file-url="false"
                    :label="$t('choose_file')"
                    type="custom-file-upload"
                    v-model="image"
                    id="image"
                    :errorMessage="$errorMessage(errors, 'image')"
            />
        </div>
    </modal>
</template>

<script>
    import ModalMixin from "../../../../Mixins/ModalMixin";
    import FormHelperMixin from "../../../../Mixins/FormHelperMixin";
    import {formDataAssigner} from "../../../../Helpers/Helpers";

    export default {
        name: "BannerCreateEdit",
        mixins: [ModalMixin, FormHelperMixin],
        data() {
            return {
                image: {}
            }
        },
        methods: {
            submitData() {
                this.fieldStatus.isSubmit = true;
                this.loading = true;
                this.message = '';
                this.errors = {};
                const formData = formDataAssigner(new FormData, this.formData);
                if (this.image && this.image instanceof File) {
                    formData.append('image', this.image);
                }
                if (this.selectedUrl) {
                    formData.append('_method', 'patch');
                }
                this.submitFromFixin(
                    'post',
                    this.selectedUrl ? this.selectedUrl : this.apiUrl.EARNERS,
                    formData
                );
            },
            afterSuccessFromGetEditData({data}) {
                this.formData = data;
                this.preloader = false;
                this.image = data.image;
                if (Boolean(data.image)) {
                    delete this.formData.image;
                }
            },
            afterSuccess({data}) {
                this.formData = {};
                $('#banner-modal').modal('hide');
                this.$emit('input', false);
                this.toastAndReload(data.message, 'earner-table');
            },
        }
    }
</script>

<style scoped>

</style>